import { render, staticRenderFns } from "./VendorDropdown.vue?vue&type=template&id=01f484a2&scoped=true"
import script from "./VendorDropdown.vue?vue&type=script&lang=js"
export * from "./VendorDropdown.vue?vue&type=script&lang=js"
import style0 from "./VendorDropdown.vue?vue&type=style&index=0&id=01f484a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f484a2",
  null
  
)

export default component.exports